import { RefObject, useEffect } from "react";
import { useSelector } from "react-redux";
import { FormikProps } from "formik";
import { ClientError, TakenEmail } from "@containers/Contact/interfaces";
import { selectError } from "@containers/Contact/store/selectors";

import { ClientFormShape } from "./formHelpers";

interface UseServerErrorsOptions {
  formikRef: RefObject<FormikProps<ClientFormShape>>;
  errorType: ClientError;
}

export const useServerErrors = ({ formikRef, errorType }: UseServerErrorsOptions) => {
  const serverError = useSelector(selectError(errorType));

  useEffect(() => {
    if (!formikRef.current) {
      return;
    }

    const formik = formikRef.current;

    const setUniqueEmailError = (field: string, takenEmail: TakenEmail) => {
      const msg = `This email is already assigned to ${takenEmail.owned_by}. Please enter a unique email.`;
      formik.setFieldTouched(field, true, false);
      formik.setFieldError(field, msg);
    };

    if (serverError && serverError.meta) {
      const taken = serverError.meta.taken as TakenEmail[];

      if (taken) {
        const primaryTaken = taken.find(({ email }) => email === formik.values.email);

        if (primaryTaken) {
          setUniqueEmailError("email", primaryTaken);
        }

        for (const index in formik.values.additional_emails || []) {
          const secondaryEmail = formik.values.additional_emails?.[index];
          const secondaryTaken = taken.find(({ email }) => email === secondaryEmail);

          if (secondaryTaken) {
            setUniqueEmailError(`additional_emails[${index}]`, secondaryTaken);
          }
        }
      }
    }
  }, [serverError, formikRef]);
};
